import React, { useState, useEffect } from "react";
import "./shift.edit.css";
import {
  Space,
  Typography,
  Button,
  Form,
  Select,
  InputNumber,
  DatePicker,
} from "antd";
import moment from "moment";
import {
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  RollbackOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { getBatchList } from "../../../services/batch.service";
import { getZoneList } from "../../../services/zone.service";
import {
  openNotification,
  swalNotification,
} from "../../../components/alret/notificztion";
import Pageloader from "../../../components/loader";
import { useParams } from "react-router-dom";
import { getSingleShift, shiftEdit, getShiftTypes } from "../../../services/shift.service";
import ErrorList from "antd/lib/form/ErrorList";
import { validationErrors } from "../../../utils/Helpers";
import { useNavigate } from "react-router-dom";

// const { Column, ColumnGroup } = Table;
const { Text, Title } = Typography;
const { RangePicker } = DatePicker;
// const { confirm } = Modal;

// const showConfirm = () => {
//   confirm({
//     title: "Do you Want to delete these items?",
//     icon: <ExclamationCircleOutlined />,
//     content: "Some descriptions",
//     onOk() {
//       console.log("OK");
//     },
//     onCancel() {
//       console.log("Cancel");
//     },
//   });
// };

const ShiftEdit = () => {
  const { shiftId } = useParams();
  // console.log("shift id", shiftId);
  const pagename = "Shift";
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [zoneData, setZoneData] = useState(null);
  const [shiftTypesData, setShiftTypesData] = useState(null);
  const [shiftData, setShiftData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  const [startTime, setStartTime] = useState(null);

  // useEffect(() => {
  //   if (postData) {
  //     setErrMsg(null);
  //   }
  // }, [postData]);
  // useEffect(() => {
  //   if (errMsg) {
  //     setPostData(null);
  //     setZoneData(null);
  //     setShiftData(null);
  //   }
  // }, [errMsg]);
  // const [isModalVisible, setIsModalVisible] = useState(false);
  useEffect(() => {
    postLists();
    // getShift();
  }, []);
  // const { RangePicker } = DatePicker;
  const postLists = async () => {
    try {
      setLoading(true);

      const shift = await getSingleShift(shiftId);
      // console.log("get single shift", shift);
      setShiftData(shift.data.data);

      const resp = await getBatchList();
      // console.log("postLists", resp.data.data);
      setPostData(resp.data.data);

      const zones = await getZoneList();
      // console.log("zoneLists", zones);
      setZoneData(zones.data.data);

      const shiftTypes = await getShiftTypes();
      setShiftTypesData(shiftTypes.data.data);

      // const shift = await getSingleShift(shiftId);
      // console.log("get single shift", shift);
      // setShiftData(shift.data.data);
    } catch (error) {
      // setErrMsg("Something went wrong");
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const getShift = async () => {
    try {
      setLoading(true);
      const shift = await getSingleShift(shiftId);
      // console.log("get single shift", shift);
      setShiftData(shift.data.data);
    } catch (error) {
      // setErrMsg("Something went wrong");
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (value, dateString) => {
    // console.log("Selected Time: ", value);
    // console.log("Formatted Selected Time: ", dateString);
    // console.log("Formatted Selected Time: ", moment(dateString).format("X"));
    setStartTime(moment(dateString).format("X"));
  };

  const onFinish = async (values) => {
    // console.log("on change start time", startTime);
    // console.log("timestamp value", moment(values.starttime).format("X"));
    if (values.starttime !== undefined) {
      let shift_duration = moment.duration(
        moment(values.endtime._d).diff(moment(values.starttime._d))
      );
      if (shift_duration < 0) {
        swalNotification(
          "Start and End time Issue",
          "End time must be greater than start time",
          "error"
        );
        return null;
      }
      values.startTime = moment(values.starttime).format("X");
      values.shiftDuration = shift_duration.asHours().toFixed(1);
    }
    // else {
    //   values.startTime = shiftData.startTime;
    // }
    // delete values["start"];
    // console.log("values", values);
    // return null;
    const newData = values;
    newData.shiftId = shiftId;
    if (typeof newData.zone === "object") {
      newData.zone = newData.zone.id;
    }
    // newData.zone = shiftId;
    // newData.startTime = moment(values.startTime).format("X");
    // console.log("new data on confirm", newData);
    // let single_shift_data = [];
    // newData.map((v, i) => {

    //   let startTime = moment(v.startTime).format("X");
    //   single_shift_data.push({ ...v, startTime });
    // });
    // console.log("data ",batch_data)
    // console.log("single shift data", newData);
    // return null;
    if (newData.batchList === undefined) {
      swalNotification("Edit Shift", "Please add atleast 1 Batch", "error");
      return null;
    }

    // console.log("newData batch list", newData.batchList);
    let batchTotalSlots = 0;
    newData.batchList.map((v, i) => {
      batchTotalSlots += v.maxSlots;
    });
    // console.log("batch Total Slots and total slots",batchTotalSlots, newData.totalSlots)
    if (batchTotalSlots < newData.totalSlots) {
      swalNotification(
        "Validation Errors",
        "Slots Quota must be greater than OR equal to total slots",
        "error"
      );
      return null;
    }

    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const resp = await shiftEdit(newData);
      // console.log("single shift add", resp.data);
      if (resp.data.code == 200) {
        swalNotification("Shift edit", resp.data.message, "success");
        postLists();
      }
    } catch (error) {
      validationErrors(error);
      // openNotification("There was an error!", error.message, "error");
      // console.error("There was an error!", error.message);
    }
  };
  const range = (start, end) => {
    const result = [];

    for (let i = start; i < end; i++) {
      result.push(i);
    }

    return result;
  }; // eslint-disable-next-line arrow-body-style

  const disabledDate = (current) => {
    // Can not select days before today and today
    // return current && current < moment().endOf("day");
    return current && current < moment();
  };

  const disabledDateTime = () => ({
    disabledHours: () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(30, 60),
    disabledSeconds: () => [55, 56],
  });

  const [data, setData] = useState([]); //store the newData with disabled added
  const [prevKey, setPrevKey] = useState(null); //store the last changed option

  let optionValues = [];
  const handleOnValuesChange = (key, val) => {
    // console.log("selected key", key);
    const updating = [...postData];
    setPrevKey(val.value);
    postData.map((d, i) => {
      // console.log("key " + key + " val " + val.value);
      if (d.batch.id === val.value) {
        optionValues.push(optionValues[i], d.batch.id);
        updating[i] = {
          ...d,
          disabled: true,
        };
      }
      if (d.batch.id === prevKey) {
        //this toggles the previous selected value to false
        updating[i] = {
          ...d,
          disabled: false,
        };
      }
      if (d.batch.id === prevKey) {
        //this toggles the previous selected value to false
        updating[i] = {
          ...d,
          disabled: false,
        };
      }
    });
    // console.log("option values", optionValues);
    // console.log("updating", updating);
    setPostData(updating);
  };

  // console.log("initial values", shiftData);
  // return null;
  // const initialValues = {
  //   batchList: shiftData.batchList
  // }
  // delete shiftData["_id"]

  return loading ? (
    <Pageloader />
  ) : (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>{pagename} Edit</Title>
        </div>
        <div className="pch-content">
          <Button onClick={() => navigate("/shifts")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>
      <Text>
        Shift ID <b>{shiftData && shiftData.display_id}</b>
      </Text>
      {shiftData && (
        <Form initialValues={shiftData} onFinish={onFinish}>
          <div className="customTable">
            <table>
              <thead>
              <tr>
                <th>Zone</th>
                <th>Start Date Time</th>
                <th>End Date Time</th>
                <th>Total Slots</th>
                <th>Shift Types</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <Form.Item
                      name={"zone"}
                      valuePropName="option"
                      rules={[{required: true, message: "Zone is Required"}]}
                      initialValue={shiftData.zone.id}
                  >
                    <Select
                        showSearch
                        placeholder="Select a Zone"
                        optionFilterProp="children"
                        value={shiftData.zone.id}
                    >
                      {zoneData &&
                          zoneData.map((zone) => {
                            return (
                                <Select.Option key={zone.id} value={zone.id}>
                                  {zone.zoneName}
                                </Select.Option>
                            );
                          })}
                    </Select>
                  </Form.Item>
                </td>
                <td>
                  <Form.Item
                      name={"starttime"}
                      rules={[
                        {
                          required: true,
                          message: "Please add start date time",
                        },
                      ]}
                      initialValue={moment(shiftData.startTime * 1000)}
                      // label="Start Time"
                      // rules={[{ required: true }]}
                  >
                    {/* <RangePicker showTime/> */}
                    <DatePicker
                        format="YYYY-MM-DD HH:mm:ss"
                        // value={moment(shiftData.startTime * 1000)}
                        showTime
                        onChange={onChange}
                        disabledDate={disabledDate}
                        // disabledTime={disabledDateTime}
                        // showTime={{
                        //   defaultValue: moment(shiftData.startTime*1000, "YYYY-MM-DD HH:mm:ss"),
                        // }}
                        // defaultValue={moment(shiftData.startTime * 1000)}
                    />
                  </Form.Item>
                </td>
                <td>
                  <Form.Item
                      name={"endtime"}
                      rules={[
                        {
                          required: true,
                          message: "Please add end date time",
                        },
                      ]}
                      initialValue={moment(shiftData.endTime * 1000)}
                      // label="Start Time"
                      // rules={[{ required: true }]}
                  >
                    {/* <RangePicker showTime/> */}
                    <DatePicker
                        format="YYYY-MM-DD HH:mm:ss"
                        // value={moment(shiftData.startTime * 1000)}
                        showTime
                        onChange={onChange}
                        disabledDate={disabledDate}
                        // disabledTime={disabledDateTime}
                        // showTime={{
                        //   defaultValue: moment(shiftData.startTime*1000, "YYYY-MM-DD HH:mm:ss"),
                        // }}
                        // defaultValue={moment(shiftData.endTime * 1000)}
                    />
                  </Form.Item>
                </td>
                {/* <td>
                  <Form.Item
                    name={"shiftDuration"}
                    rules={[
                      {
                        required: true,
                        message: "Please add shift duration hours",
                      },
                    ]}
                  >
                    <InputNumber placeholder="Shift Duration" min={0.01} />
                  </Form.Item>
                </td> */}
                <td>
                  <Form.Item
                      name={"totalSlots"}
                      rules={[
                        {
                          required: true,
                          message: "Please add total number of slots",
                        },
                      ]}
                  >
                    <InputNumber
                        placeholder="Total Slots"
                        min={1}
                        formatter={(value) => `${value}`}
                        parser={(value) => value.replace(".", "")}
                    />
                  </Form.Item>
                </td>
                <td>
                  <Form.Item
                      name={"type"}
                      rules={[{required: true, message: 'Shift Type is required'}]}
                  >
                    <Select
                        showSearch
                        placeholder="Select a Shift Type"
                        optionFilterProp="children"
                        value={shiftData.type}
                    >
                      {shiftTypesData &&
                          shiftTypesData.map((shiftType) => {
                            return (
                                <Select.Option key={shiftType} value={shiftType}>
                                  {shiftType}
                                </Select.Option>
                            );
                          })}
                    </Select>
                  </Form.Item>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <Form.List name={"batchList"}>
            {(fields, {add, remove}) => (
                <div className="customTable">
                  <table>
                    <thead>
                    <tr>
                      <th>Batch</th>
                      <th>Slots Quota</th>
                      <th>Show Time(Hours)</th>
                      <th>Expiry Time(Hours)</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {fields.map((field, index) => {
                      return (
                          <tr key={field.key}>
                            <td>
                              <Form.Item
                                  key={field.key}
                              name={[field.name, "batchId"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Batch Level is Required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Batch"
                                onChange={(key, val) =>
                                  handleOnValuesChange(key, val)
                                }
                              >
                                {postData.map((b, i) => {
                                  return (
                                    <Select.Option
                                      key={b.batch.id}
                                      value={b.batch.id}
                                      disabled={b.disabled}
                                    >
                                      {b.batch.batchLevel}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              key={field.key}
                              name={[field.name, "maxSlots"]}
                              // label={`${index + 1}-batch`}
                              rules={[
                                {
                                  required: true,
                                  message: "Slots is Required",
                                },
                              ]}
                            >
                              <InputNumber
                                placeholder="Slots Quota"
                                min={1}
                                // prefix={<PercentageOutlined />}
                                formatter={(value) => `${value}`}
                                parser={(value) => value.replace(".", "")}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              key={field.key}
                              name={[field.name, "startDisplayHours"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Show Time is Required",
                                },
                              ]}
                            >
                              <InputNumber
                                placeholder="Show Time(Hours)"
                                min={0.01}
                                prefix={<ClockCircleOutlined />}
                                // formatter={(value) => `${value}`}
                                // parser={(value) => value.replace(".", "")}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              key={field.key}
                              name={[field.name, "endDisplayHours"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Expiry Time is Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0.01}
                                placeholder="Expiry Time(Hours)"
                                prefix={<ClockCircleOutlined />}
                                // formatter={(value) => `${value}`}
                                // parser={(value) => value.replace(".", "")}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <MinusCircleOutlined
                              style={{ height: 40, color: "red" }}
                              onClick={() => remove(field.name)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    {fields.length > 5 ? (
                      ""
                    ) : (
                      <tr>
                        <td colSpan={5}>
                          <Form.Item>
                            <Button
                              icon={<PlusOutlined />}
                              onClick={() => {
                                add();
                              }}
                              style={{ maxWidth: "250px" }}
                            >
                              Add a Batch
                            </Button>
                          </Form.Item>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </Form.List>
          <Form.Item>
            <Button className="submit" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      )}
    </div>
  );
};

export default ShiftEdit;
